import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MenuController, LoadingController } from '@ionic/angular';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { CartService } from '../../services/cart.service';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { User } from 'src/app/classes/user';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  userData: User = {};
  cart = [];

  darkMode = true;

  constructor(
    public fireAuth: AngularFireAuth,
    public auth: AuthenticationService,
    public cartService: CartService,
    public loadingCtrl: LoadingController,
    private menuCtrl: MenuController,
    private router: Router,
    private iab: InAppBrowser
  ) {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
    this.darkMode = prefersDark.matches;
  }

  ngOnInit() {
    this.userData = this.auth.getUserData();
    this.cart = this.cartService.getCart();
  }

  prefersColor() {
    document.body.classList.toggle( 'dark' );
  }

  openLocations() {
    this.router.navigate(['location']);
  }

  openCart() {
    // this.router.navigate(['cart']);
  }

  openHistory() {
    this.router.navigate(['history']);
  }

  openPolicy() {
    const browser = this.iab.create(
      'https://www.venalispos.com/avisodeprivacidad',
      '_blank',
      'hideurlbar=yes'
    );
    browser.show();
  }

  logout() {
    this.presentLoading('Cerrando sesión...', 2000);
    this.fireAuth.signOut().then(() => {
      this.userData = {};
      this.closeMenu();
      this.router.navigate(['login']);
    });
  }

  async presentLoading(message, duration) {
    const loading = await this.loadingCtrl.create({
      message,
      duration
    });
    await loading.present();
  }

  async closeLoading() {
    return await this.loadingCtrl.dismiss();
  }

  async closeMenu() {
    if (await this.menuCtrl.isOpen()) {
      await this.menuCtrl.close();
      await this.menuCtrl.enable(false, 'primerMenu');
    }
  }
}
